<template>
  <div
    id="__videas-player"
    ref="videasPlayer"
    :style="playerStyle"
    :class="playerClass"
  >
    <player-icons></player-icons>

    <!--
    <context-menu
      v-model="showContextMenu"
      :x="contextMenuX"
      :y="contextMenuY"
    ></context-menu>
    -->

    <div
      class="v-video-container"
      @click="mouseClickVideo"
      @mousemove="mouseOverVideo"
      @contextmenu="toggleContextMenu"
    >
      <video
        :class="{ 'hide-cursor': !state.controlsShow }"
        class="v-video"
        ref="video"
      ></video>

      <div class="v-video-overlay" v-if="options.showHeroButton && displayHero">
        <button type="button" class="v-video-control play-hero" @click="play">
          <svg role="presentation" focusable="false" viewBox="0 0 18 18">
            <use xlink:href="#icon-play"></use>
          </svg>
        </button>
      </div>

      <div
        class="v-video-title"
        v-if="options.showVideoTitle && state.controlsShow"
      >
        <h2 class="white--text font-weight-bold">{{ media.name }}</h2>
      </div>

      <v-video-controls
        :videoState="videoState"
        :themeOptions="options"
        v-show="
          options.showControls &&
            ((state.controlsShow && !displayHero) ||
              (displayHero && options.showControlsStart))
        "
      ></v-video-controls>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import playerIcons from "../assets/icons.vue";

import VVideoControls from "./controls";

import Analytics from "../analytics";

import Hls from "hls.js";

const eventBus = new Vue();

export default {
  // mixins: [Analytics],
  components: {
    playerIcons,
    VVideoControls
  },
  props: {
    src: {
      type: String,
      required: true
    },
    analyticsActive: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      $video: null,

      displayHero: true,

      selectedQuality: "480",
      videoSource: "",

      tmp: {
        contrlHideTimer: null
      },
      state: {
        controlsShow: true,
        chaptersToggle: false,
        vol: 0.85,
        currentTime: 0,
        fullScreen: false,
        playing: false,
        videoEnded: false
      },
      videoState: {
        currentTime: 0,
        duration: 0,
        playing: false,
        fullScreen: false
      },

      analytics: null
    };
  },
  provide() {
    return { eventBus };
  },
  mounted() {
    document.body.addEventListener("mousemove", this.mouseMoveAction, false);

    eventBus.$on("video.play", this.play);
    eventBus.$on("video.fullscreen", this.fullScreen);
    eventBus.$on("video.setCurrentTime", this.setVideoTime);

    this.$nextTick(() => {
      this.initCore();
      this.startHls();
    });

    if (this.analyticsActive) {
      try {
        this.analytics = new Analytics(this.media, this.share, eventBus);
      } catch (exception) {
        console.log(exception);
      }
    }
  },
  beforeDestroy() {
    document.body.removeEventListener("mousemove", this.mouseMoveAction);
    document.body.removeEventListener("mouseup", this.mouseUpAction);
    // window.removeEventListener("resize", this.throttleResize);

    eventBus.$off("player.play", this.play);
    eventBus.$off("player.fullscreen", this.fullScreen);
  },
  computed: {
    playerStyle() {
      return {
        "--player-color": this.options.colors.icons,
        "--player-btn-color": this.options.colors.icons
      };
    },
    playerClass() {
      return {
        "v-hide-controls": !this.state.controlsShow
      };
    },
    thumbnail() {
      return "";
    }
  },
  methods: {
    startHls() {
      if (Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(this.src);
        hls.attachMedia(this.$video);
        hls.on(Hls.Events.MANIFEST_PARSED, function() {
          this.play();
        });
      }
      // hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
      // When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element through the `src` property.
      // This is using the built-in support of the plain video element, without using hls.js.
      // Note: it would be more normal to wait on the 'canplay' event below however on Safari (where you are most likely to find built-in HLS support) the video.src URL must be on the user-driven
      // white-list before a 'canplay' event will be emitted; the last video event that can be reliably listened-for when the URL is not on the white-list is 'loadedmetadata'.
      else if (this.$video.canPlayType("application/vnd.apple.mpegurl")) {
        this.$video.src = this.src;
        this.$video.addEventListener("loadedmetadata", function() {
          this.play();
        });
      }
    },
    initCore() {
      this.$video = this.$refs["video"];
    },
    play() {
      this.state.playing = !this.state.playing;
      this.videoState.playing = !this.videoState.playing;
      this.displayHero = false;
      this.state.videoEnded = false;
      if (this.$video) {
        if (this.state.playing) {
          this.$video.play();
          // this.mouseLeaveVideo();
          this.$video.addEventListener("timeupdate", this.timeUpdate);
          this.$video.addEventListener("ended", this.videoEnded);
        } else {
          this.$video.pause();
          this.$video.removeEventListener("timeupdate", this.timeUpdate);
          this.$video.removeEventListener("ended", this.videoEnded);
        }
      }
    },
    videoEnded() {
      this.$video.removeEventListener("timeupdate", this.timeUpdate);
      this.$video.removeEventListener("ended", this.videoEnded);
      this.state.playing = false;
    },
    timeUpdate() {
      this.videoState.currentTime = this.$video.currentTime;
      this.videoState.duration = this.$video.duration;
      eventBus.$emit("video.timeupdate", {
        currentTime: this.videoState.currentTime
      });
    },
    toggleContextMenu(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    fullScreen() {
      var isInFullScreen =
        (document.fullscreenElement && true) ||
        (document.webkitFullscreenElement && true) ||
        (document.mozFullScreenElement && true) ||
        (document.msFullscreenElement && true);

      var docElm = this.$refs["videasPlayer"];
      if (!isInFullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen();
        }
        this.state.fullScreen = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.state.fullScreen = false;
      }
    },
    mouseOverVideo() {
      if (this.tmp.contrlHideTimer) {
        clearTimeout(this.tmp.contrlHideTimer);
        this.tmp.contrlHideTimer = null;
      }
      this.state.controlsShow = true;
      this.tmp.contrlHideTimer = setTimeout(() => {
        this.state.controlsShow = false;
        this.tmp.contrlHideTimer = null;
      }, 3000);
    },
    mouseClickVideo(e) {
      if (e.target.classList.contains("v-video")) {
        this.play();
      }
    },
    setVideoTime({ time }) {
      this.$video.currentTime = time;
    }
  }
};
</script>

<style lang="stylus">
#__videas-player:-webkit-full-screen
  width: 100%
  height: 100%

#__videas-player
  overflow: hidden;
  background-color: #000;
  color: #fff;
  height: 100%;
  user-select: none;
  position: relative;

  ::-webkit-media-controls
    display: none !important;

  video:-webkit-full-screen
    width: 100%;
    height: 100%;
    max-height: 100%;

  &:fullscreen, &:-ms-fullscreen,
  &:-moz-full-screen, &:-webkit-full-screen
    width: 100%;
    height: 100%;

  &.v-hide-controls
    cursor: none !important;

  svg
    fill: currentColor;

  .v-video-container
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #000;

  .v-video
    width: 100%;
    height: 100%;
    vertical-align: bottom;

  .v-video-title
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 20px;
    padding-bottom: 40px;
    background: linear-gradient(rgba(0, 0, 0, .6), rgba(0, 0, 0, 0));

  .v-video-overlay
    background-color: rgba(0, 0, 0, 0.60);
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    white-space: pre-wrap;
    text-align: center;

    a
      color: #FFF;
      font-size: 30px;
      font-weight: 600;

    button.play-hero
      background: var(--player-color, #884AFF);
      width: 70px;
      height: 70px;
      border: 0;
      border-radius: 15px;
      padding: 14px 23px;

      svg
        filter: drop-shadow(0 1px 3px rgba(0, 0, 0, .2));
        width: 30px;
        height: 30px;

    .v-btn
      height: 50px;

      &, i
        font-size: 27px;

    .v-input__slot
      background-color: #fff !important;

  .v-video-control
    background: 0 0;
    border: 0;
    border-radius: 3px;
    color: inherit;
    cursor: pointer;
    flex-shrink: 0;
    overflow: visible;
    padding: 6px;
    position: relative;
    transition: all .3s ease;

    svg
      display: block;
      filter: drop-shadow(0 1px 3px rgba(0, 0, 0, .50));
      fill: currentColor;
      height: 18px;
      pointer-events: none;
      width: 18px;

    &:hover
      background: var(--player-color, #884AFF);
      color: #fff;

    &:focus
      outline: 0;


.v-video-control-volume-progress
  position: relative;
  display: inline-block;
  height: 100px;
  transition: all .2s ease-in;

  .v-video-control-volume-progress-rail
    position: absolute;
    left: 50%;
    width: .3rem;
    height: 100%;
    margin-left: -.15rem;
    background: rgba(255, 255, 255, 0.5);
    overflow: hidden;

  .v-video-control-volume-progress-rail-inner
    position: absolute;
    top: 100%;
    left: 50%;
    width: .3rem;
    height: 100%;
    margin-left: -.15rem;
    background: var(--player-color, #884AFF);
    transition: transform .2s;

  .v-video-control-volume-progress-inner
    position: absolute;
    display: inline-block;
    left: 50%;
    bottom: 0;
    background: #fff;
    width: .8rem;
    height: .8rem;
    border-radius: 50%;
    margin-left: -.4rem;
    margin-bottom: -.4rem;
    z-index: 2;
    cursor: pointer;
    transition: all 16ms;

.v-video-list
  .v-list
    // background: rgba(255,255,255,.9);
    border-radius: 5px;

  .v-list--dense .v-list-item
    height: 30px;
    font-weight: 600;
    color: #838383
    padding: 0 5px;

  .v-list--dense .v-list-item .v-icon
    font-size: 16px;

  .v-list--dense .v-list-item .v-icon.active
    font-size: 16px;
    background-color: #884aff;
    border-radius: 50%;
    color: #fff;

  .theme--light.v-list .v-list-item--link:hover
    color: #000;
    border-radius: 4px;

  .v-list-item__title
    transition: none;

#quality-menu
  .v-menu__content
    max-width: none;
</style>
